import { createFileRoute } from "@tanstack/react-router";

import { AdminAuthForm } from "@/components/forms/admin-auth-form";
import { Image } from "@/components/image";
import { Logo } from "@/components/logo";
import { SUPPORT_EMAIL } from "@/lib/support";

const AuthenticationPage = () => (
  <div className="container relative hidden min-h-[100dvh] flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0">
    <div className="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
      <div className="absolute inset-0 bg-zinc-900">
        <Image
          src="/img/20170222-OSCAR-Radio-001-scaled.jpg"
          width={1280}
          height={843}
          alt="Authentication"
          className="block h-full object-cover"
        />
      </div>
      <div className="relative z-20 flex items-center text-lg font-medium gap-4">
        <Logo forDirectors={true} />
      </div>
    </div>
    <div className="lg:p-8">
      <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
        <div className="flex flex-col space-y-2 text-center">
          <h1 className="text-2xl font-semibold tracking-tight">
            Log in as director or supervisor
          </h1>
          <p className="text-sm text-muted-foreground">
            If you&apos;re an admin, you&apos;ll be able to sign in below
          </p>
        </div>
        <AdminAuthForm />
        <p className="px-8 text-center text-sm text-muted-foreground">
          Can&apos;t log in?{" "}
          <a
            href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent("OSCAR Radio login help")}`}
            className="font-medium text-foreground underline-offset-4 hover:underline"
          >
            Contact support
          </a>
        </p>
      </div>
    </div>
  </div>
);

export const Route = createFileRoute("/login")({
  component: AuthenticationPage,
  head: () => ({
    meta: [
      { title: "Log in · OSCAR Radio" },
      {
        content: "Sign in to manage OSCAR Radio.",
        name: "description",
      },
    ],
  }),
});
